/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import ViewGrid from '@react/react-spectrum/Icon/ViewGrid';
import Refresh from '@react/react-spectrum/Icon/Refresh';
import DeviceDesktop from '@react/react-spectrum/Icon/DeviceDesktop';
import DevicePhone from '@react/react-spectrum/Icon/DevicePhone';
import WebPage from '@react/react-spectrum/Icon/WebPage';
import CloseCircle from '@react/react-spectrum/Icon/CloseCircle';
import CheckmarkCircle from '@react/react-spectrum/Icon/CheckmarkCircle';
import ArrowLeft from '@react/react-spectrum/Icon/core/ArrowLeftMedium';
import LinkOut from '@react/react-spectrum/Icon/LinkOut';
import Alert from '@react/react-spectrum/Icon/Alert';
import Apple from '@react/react-spectrum/Icon/Apple';
import Android from '@react/react-spectrum/Icon/Android';
import ChevronRight from '@react/react-spectrum/Icon/ChevronRight';
import ChevronDown from '@react/react-spectrum/Icon/ChevronDown';
import Windows from '@react/react-spectrum/Icon/Windows8';
import Graphic from '@react/react-spectrum/Icon/Graphic';
import Camera from '@react/react-spectrum/Icon/Camera';
import VideoFilled from '@react/react-spectrum/Icon/VideoFilled';
import Brush from '@react/react-spectrum/Icon/Brush';
import DesktopAndMobile from '@react/react-spectrum/Icon/DesktopAndMobile';
import Beaker from '@react/react-spectrum/Icon/Beaker';
import Stock from '@react/react-spectrum/Icon/Stock';
import Behance from '@react/react-spectrum/Icon/Behance';
import Education from '@react/react-spectrum/Icon/Education';
import Apps from '@react/react-spectrum/Icon/Apps';
import Download from '@react/react-spectrum/Icon/Download';
import CreativeCloud from '@react/react-spectrum/Icon/CreativeCloud';
import ImageAutoMode from '@react/react-spectrum/Icon/ImageAutoMode';
import Edit from '@react/react-spectrum/Icon/Edit';
import SocialNetwork from '@react/react-spectrum/Icon/SocialNetwork';
import Cut from '@react/react-spectrum/Icon/Cut';
import MovieCamera from '@react/react-spectrum/Icon/MovieCamera';
import Layers from '@react/react-spectrum/Icon/Layers';
import VectorDraw from '@react/react-spectrum/Icon/VectorDraw';
import Shapes from '@react/react-spectrum/Icon/Shapes';
import CloneStamp from '@react/react-spectrum/Icon/CloneStamp';
import Data from '@react/react-spectrum/Icon/Data';
import Link from '@react/react-spectrum/Icon/Link';
import Preset from '@react/react-spectrum/Icon/Preset';
import Cloud from '@react/react-spectrum/Icon/Cloud';
import Print from '@react/react-spectrum/Icon/Print';
import UserGroup from '@react/react-spectrum/Icon/UserGroup';
import News from '@react/react-spectrum/Icon/News';
import ThreeDMaterials from '@react/react-spectrum/Icon/3DMaterials';
import OneTwoThree from '@react/react-spectrum/Icon/123';

export default {
    ViewGrid,
    Refresh,
    DeviceDesktop,
    DevicePhone,
    WebPage,
    ArrowLeft,
    LinkOut,
    CheckmarkCircle,
    CloseCircle,
    Alert,
    Apple,
    Android,
    ChevronRight,
    ChevronDown,
    Windows,
    Graphic,
    Camera,
    VideoFilled,
    Brush,
    DesktopAndMobile,
    Beaker,
    Behance,
    Stock,
    Education,
    Apps,
    Download,
    CreativeCloud,
    ImageAutoMode,
    Edit,
    SocialNetwork,
    Cut,
    MovieCamera,
    Layers,
    VectorDraw,
    Shapes,
    CloneStamp,
    iPadOS: Apple,
    Data,
    Link,
    Preset,
    Cloud,
    Print,
    UserGroup,
    News,
    '3DMaterials': ThreeDMaterials,
    123: OneTwoThree,
};
